// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
import { takeLatest, put, all, call } from 'redux-saga/effects';
import businessCollectionActionTypes from './business-collection.types';
import {
	fetchSearchBusinessLoanList,
	fetchBusinessLoanInfo,
	businessCollectionUpdateAPI,
	businessDeathUpdateAPI,
	businessInterestWaiverUpdateAPI,
	businessCollectionRevertAPI,
	businessCollectionFetchAPI,
	businessWalletFetchAPI,
	businessQrFetchAPI,
	businessRepaymentFetchAPI,
	businessWalletRevertAPI,
	getBusinessLoanCardPDF,
	geBusinessLoanCardReport,
	getBusinessRepaymentPDF,
	businessLoanCollectionApprovalAPI,
	businessWalletAddAPI,
	businessLoanPaidEntry,
	businessArrearLoanPaidEntry,
} from './business-collection.service';
import {
	getSearchBusinessLoanListSuccess,
	getSearchBusinessLoanListFailure,
	getSearchBusinessLoanListResponseChanged,
	getBusinessLoanInfoSuccess,
	getBusinessLoanInfoFailure,
	getBusinessLoanInfoResponseChanged,
	updateBusinessCollectionResponseChanged,
	updateBusinessCollectionSuccess,
	updateBusinessCollectionFailure,
	updateBusinessDeathResponseChanged,
	updateBusinessDeathSuccess,
	updateBusinessDeathFailure,
	updateBusinessInterestWaiverResponseChanged,
	updateBusinessInterestWaiverSuccess,
	updateBusinessInterestWaiverFailure,
	revertBusinessCollectionResponseChanged,
	revertBusinessCollectionSuccess,
	revertBusinessCollectionFailure,
	fetchBusinessCollectionResponseChanged,
	fetchBusinessCollectionSuccess,
	fetchBusinessCollectionFailure,
	fetchBusinessWalletResponseChanged,
	fetchBusinessWalletSuccess,
	fetchBusinessWalletFailure,
	addBusinessWalletSuccess,
	addBusinessWalletFailure,
	addBusinessWalletResponseChanged,
	fetchBusinessQrResponseChanged,
	fetchBusinessQrSuccess,
	fetchBusinessQrFailure,
	fetchBusinessRepaymentResponseChanged,
	fetchBusinessRepaymentSuccess,
	fetchBusinessRepaymentFailure,
	revertBusinessWalletFailure,
	revertBusinessWalletResponseChanged,
	revertBusinessWalletSuccess,
	getBusinessLoanCardPDFFailure,
	getBusinessLoanCardPDFSuccess,
	getBusinessLoanCardPDFResponseChanged,
	getBusinessRepaymentPDFFailure,
	getBusinessRepaymentPDFSuccess,
	getBusinessLoanCardReportFailure,
	getBusinessLoanCardReportSuccess,
	getBusinessLoanCardReportResponseChanged,
	businessLoanCollectionApprovalFailure,
	businessLoanCollectionApprovalSuccess,
	businessLoanCollectionApprovalResponseChanged,
	businessCollectionLoanPaidArrearFailure,
	businessCollectionLoanPaidArrearSuccess,
	businessCollectionLoanPaidArrearReponseChanged,
	businessCollectionLoanPaidFailure,
	businessCollectionLoanPaidSuccess,
	businessCollectionLoanPaidReponseChanged,
} from './business-collection.action';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
import { memberArrearLoanPaidEntry } from '../member-collection/member-collection.service';
/** *********************  START SEARCH BUSINESS LOAN LIST DETAILS  ******************** */
export function* getSearchBusinessLoanList({ payload }: any) {
	try {
		const key = 'searchBusinessLoanListKey';
		const {
			searchBusinessValue,
			searchBusinessType,
			companyID,
			userID,
			userRole,
			userLevel,
			databaseName,
			provisionType,
		} = payload;
		const jsonData = {
			SearchBusinessValue: searchBusinessValue,
			SearchBusinessType: searchBusinessType,
			CompanyID: companyID,
			UserID: userID,
			UserRole: userRole,
			Level: userLevel,
			DatabaseName: databaseName,
			ProvisionType: provisionType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchSearchBusinessLoanList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getSearchBusinessLoanListFailure(responseData.data));
		} else {
			yield put(getSearchBusinessLoanListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getSearchBusinessLoanListFailure(error));
	}
}

export function* resetGetSearchBusinessLoanListResponse() {
	yield put(getSearchBusinessLoanListResponseChanged());
}

export function* onGetSearchBusinessLoanListDetails() {
	yield takeLatest(
		businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_START,
		getSearchBusinessLoanList,
	);
}

export function* onGetSearchBusinessLoanListResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.GET_SEARCH_BUSINESS_LOAN_LIST_RESPONSE_RESET,
		resetGetSearchBusinessLoanListResponse,
	);
}
/** *********************  END GET SEARCH BUSINESS LOAN LIST  ******************** */

/** *********************  START BUSINESS LOAN INFO DETAILS  ******************** */
export function* getBusinessLoanInfo({ payload }: any) {
	try {
		const key = 'LoanInfoMemberLoanListKey';
		const { loanIndexGroupMemberID, memberID, companyID, databaseName } = payload;
		const jsonData = {
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			CompanyID: companyID,
			DatabaseName: databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchBusinessLoanInfo, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBusinessLoanInfoFailure(responseData.data));
		} else {
			yield put(getBusinessLoanInfoSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBusinessLoanInfoFailure(error));
	}
}

export function* resetGetBusinessLoanInfoResponse() {
	yield put(getBusinessLoanInfoResponseChanged());
}

export function* onGetBusinessLoanInfoDetails() {
	yield takeLatest(
		businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_START,
		getBusinessLoanInfo,
	);
}

export function* onGetBusinessLoanInfoResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.GET_BUSINESS_LOAN_INFO_RESPONSE_RESET,
		resetGetBusinessLoanInfoResponse,
	);
}
/** *********************  END GET BUSINESS LOAN INFO  ******************** */

/** *********************  START BUSINESS COLLECTION UPDATE  ******************** */
export function* updateBusinessCollectionList({ payload }: any) {
	try {
		const key = 'UpdateMemberCollectionDataKey';
		const {
			DatabaseName,
			CompanyID,
			UserID,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenominationAmount,
			BranchID,
			CenterID,
			GroupID,
			memberID,
			LoanIndexGroupMemberID,
			Amount,
			repayDate,
			receiptNumber,
			chequeNumber,
		} = payload;
		const jsonData = {
			DatabaseName: DatabaseName,
			CompanyID: CompanyID,
			UserID: UserID,
			fiveHundred: fiveHundred,
			twoHundred: twoHundred,
			hundred: hundred,
			fifty: fifty,
			twenty: twenty,
			ten: ten,
			five: five,
			two: two,
			one: one,
			totalDenominationAmount: totalDenominationAmount,
			BranchID: BranchID,
			LocationID: CenterID,
			GroupID: GroupID,
			Member: memberID,
			LoanIndexGroupMemberID: LoanIndexGroupMemberID,
			RecivedAmount: Amount,
			businessCollectionDate: repayDate,
			ReceiptNumber: receiptNumber,
			ChequeNumber: chequeNumber,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessCollectionUpdateAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessCollectionFailure(responseData.data));
		} else {
			yield put(updateBusinessCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessCollectionFailure(error));
	}
}

export function* resetBusinessCollectionUpdateResponse() {
	yield put(updateBusinessCollectionResponseChanged());
}

export function* onBusinessCollectionUpdate() {
	yield takeLatest(
		businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_START,
		updateBusinessCollectionList,
	);
}

export function* onBusinessCollectionUpdateResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.UPDATE_BUSINESS_COLLECTION_RESPONSE_RESET,
		resetBusinessCollectionUpdateResponse,
	);
}
/** *********************  END BUSINESS COLLECTION UPDATE  ******************** */

/** *********************  UPDATE BUSINESS DEATH LIST START  ******************** */
export function* updateBusinessDeathList({ payload }: any) {
	try {
		const key = 'UpdateBusinessDeathDetailsKey';
		const {
			databaseName,
			businessID,
			companyID,
			userID,
			loanIndexGroupBusinessID,
			deathDate,
			deathPlace,
			deathReason,
			isDeadDemandRequired,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupBusinessID: loanIndexGroupBusinessID,
			BusinessID: businessID,
			DeathDate: deathDate,
			DeathPlace: deathPlace,
			DeathReason: deathReason,
			IsDeadDemandRequired: isDeadDemandRequired,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessDeathUpdateAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessDeathFailure(responseData.data));
		} else {
			yield put(updateBusinessDeathSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessDeathFailure(error));
	}
}

export function* resetBusinessDeathUpdateResponse() {
	yield put(updateBusinessDeathResponseChanged());
}

export function* onBusinessDeathUpdate() {
	yield takeLatest(
		businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_START,
		updateBusinessDeathList,
	);
}

export function* onBusinessDeathUpdateResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.UPDATE_BUSINESS_DEATH_RESPONSE_RESET,
		resetBusinessDeathUpdateResponse,
	);
}
/** *********************  UPDATE BUSINESS DEATH LIST END  ******************** */

/** *********************  UPDATE INTEREST WAIVER LIST START  ******************** */
export function* updateBusinessInterestWaiverList({ payload }: any) {
	try {
		const key = 'UpdateInterestWaiverDataKey';
		const WaiverDueLoans = JSON.stringify(payload.waiverDueLoans).replace(/"/g, "'");
		const {
			databaseName,
			companyID,
			userID,
			loanIndexGroupMemberID,
			memberID,
			interestWaiverAmount,
			interestWaiverReason,
			loanIndexID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			WaiverInterest: interestWaiverAmount,
			ReasonForInterestWaiver: interestWaiverReason,
			LoanIndexID: loanIndexID,
			WaiverDueLoans,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessInterestWaiverUpdateAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessInterestWaiverFailure(responseData.data));
		} else {
			yield put(updateBusinessInterestWaiverSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessInterestWaiverFailure(error));
	}
}

export function* resetBusinessInterestWaiverUpdateResponse() {
	yield put(updateBusinessInterestWaiverResponseChanged());
}

export function* onBusinessInterestWaiverUpdate() {
	yield takeLatest(
		businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_START,
		updateBusinessInterestWaiverList,
	);
}

export function* onBusinessInterestWaiverUpdateResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.UPDATE_BUSINESS_INTEREST_WAIVER_RESPONSE_RESET,
		resetBusinessInterestWaiverUpdateResponse,
	);
}
/** *********************  UPDATE INTEREST WAIVER LIST END  ******************** */

/** *********************  REVERT BUSINESS COLLECTION LIST START ******************** */
export function* revertBusinessCollectionList({ payload }: any) {
	try {
		const key = 'RevertMemberCollectionDataKey';
		const { databaseName, companyID, userID, arrearCollectionID, loanPaidID, serviceName } =
			payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			ArrearCollectionID: arrearCollectionID,
			DueID: loanPaidID,
			ServiceName: serviceName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(
			businessCollectionRevertAPI,
			encodeData,
			jsonData.ServiceName,
		);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertBusinessCollectionFailure(responseData.data));
		} else {
			yield put(revertBusinessCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertBusinessCollectionFailure(error));
	}
}

export function* resetBusinessCollectionRevertResponse() {
	yield put(revertBusinessCollectionResponseChanged());
}

export function* onBusinessCollectionRevert() {
	yield takeLatest(
		businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_START,
		revertBusinessCollectionList,
	);
}

export function* onBusinessCollectionRevertResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.REVERT_BUSINESS_COLLECTION_RESPONSE_RESET,
		resetBusinessCollectionRevertResponse,
	);
}
/** *********************  REVERT BUSINESS COLLECTION LIST END ******************** */

/** *********************  FETCH BUSINESS COLLECTION LIST START ******************** */
export function* fetchBusinessCollectionList({ payload }: any) {
	try {
		const key = 'FetchMemberCollectionDataKey';
		const {
			databaseName,
			companyID,
			userID,
			businessID,
			loanIndexGroupBusinessID,
			amount,
			loanPaidID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			Business: businessID,
			LoanIndexGroupBusinessID: loanIndexGroupBusinessID,
			RevertAmount: amount,
			DueID: loanPaidID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessCollectionFetchAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessCollectionFailure(responseData.data));
		} else {
			yield put(fetchBusinessCollectionSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessCollectionFailure(error));
	}
}

export function* resetBusinessCollectionFetchResponse() {
	yield put(fetchBusinessCollectionResponseChanged());
}

export function* onBusinessCollectionDetailsFetch() {
	yield takeLatest(
		businessCollectionActionTypes.GET_BUSINESS_COLLECTION_START,
		fetchBusinessCollectionList,
	);
}

export function* onBusinessCollectionDetailsFetchResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.GET_BUSINESS_COLLECTION_RESPONSE_RESET,
		resetBusinessCollectionFetchResponse,
	);
}
/** *********************  FETCH BUSINESS COLLECTION LIST END ******************** */

/** *********************  FETCH BUSINESS WALLET LIST START ******************** */
export function* fetchBusinessWalletList({ payload }: any) {
	try {
		const key = 'FetchMemberWalletDataKey';
		const { databaseName, companyID, userID, loanIndexGroupMemberID, memberID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessWalletFetchAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessWalletFailure(responseData.data));
		} else {
			yield put(fetchBusinessWalletSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessWalletFailure(error));
	}
}

export function* resetBusinessWalletFetchResponse() {
	yield put(fetchBusinessWalletResponseChanged());
}

export function* onBusinessWalletDetailsFetch() {
	yield takeLatest(
		businessCollectionActionTypes.GET_BUSINESS_WALLET_START,
		fetchBusinessWalletList,
	);
}

export function* onBusinessWalletDetailsFetchResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.GET_BUSINESS_WALLET_RESPONSE_RESET,
		resetBusinessWalletFetchResponse,
	);
}
/** *********************  FETCH BUSINESS WALLET LIST END ******************** */

/** *********************  ADD BUSINESS WALLET LIST START ******************** */
export function* addBusinessWalletList({ payload }: any) {
	try {
		const key = 'AddAmountToWalletKey';
		const {
			databaseName,
			companyID,
			userID,
			loanIndexGroupMemberID,
			memberID,
			walletAmount,
			paidDate,
			loanPaidID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			WalletAmount: walletAmount,
			CreatedBy: userID,
			PaidDate: paidDate,
			LoanPaidID: loanPaidID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessWalletAddAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessWalletFailure(responseData.data));
		} else {
			yield put(addBusinessWalletSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessWalletFailure(error));
	}
}

export function* resetBusinessWalletAddResponse() {
	yield put(addBusinessWalletResponseChanged());
}

export function* onBusinessWalletDetailsAdd() {
	yield takeLatest(
		businessCollectionActionTypes.ADD_BUSINESS_WALLET_START,
		addBusinessWalletList,
	);
}

export function* onBusinessWalletDetailsAddResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.ADD_BUSINESS_WALLET_RESPONSE_RESET,
		resetBusinessWalletAddResponse,
	);
}
/** *********************  ADD BUSINESS WALLET LIST END ******************** */

/** *********************  FETCH BUSINESS QR LIST START ******************** */
export function* fetchBusinessQrList({ payload }: any) {
	try {
		const key = 'FetchMemberQrDataKey';
		const { databaseName, companyID, userID, loanIndexGroupMemberID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessQrFetchAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessQrFailure(responseData.data));
		} else {
			yield put(fetchBusinessQrSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessQrFailure(error));
	}
}

export function* resetBusinessQrFetchResponse() {
	yield put(fetchBusinessQrResponseChanged());
}

export function* onBusinessQrDetailsFetch() {
	yield takeLatest(businessCollectionActionTypes.GET_BUSINESS_QR_START, fetchBusinessQrList);
}

export function* onBusinessQrDetailsFetchResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.GET_BUSINESS_QR_RESPONSE_RESET,
		resetBusinessQrFetchResponse,
	);
}
/** *********************  FETCH BUSINESS QR LIST START ******************** */

/** *********************  FETCH BUSINESS REPAYMENT LIST START ******************** */
export function* fetchBusinessRepaymentList({ payload }: any) {
	try {
		const key = 'FetchMemberRepaymentDataKey';
		const { databaseName, companyID, loanIndexGroupMemberID, memberID, branchID, centerID } =
			payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			BranchID: branchID,
			CenterID: centerID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessRepaymentFetchAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessRepaymentFailure(responseData.data));
		} else {
			yield put(fetchBusinessRepaymentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessRepaymentFailure(error));
	}
}

export function* resetBusinessRepaymentFetchResponse() {
	yield put(fetchBusinessRepaymentResponseChanged());
}

export function* onBusinessRepaymentDetailsFetch() {
	yield takeLatest(
		businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_START,
		fetchBusinessRepaymentList,
	);
}

export function* onBusinessRepaymentDetailsFetchResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.GET_BUSINESS_REPAYMENT_RESPONSE_RESET,
		resetBusinessRepaymentFetchResponse,
	);
}
/** *********************  FETCH BUSINESS REPAYMMENT LIST START ******************** */

/** *********************  REVERT BUSINESS WALLET LIST START ******************** */
export function* revertBusinessWalletList({ payload }: any) {
	try {
		const key = 'RevertMemberWalletDataKey';
		const { databaseName, companyID, userID, loanIndexGroupMemberID, savingAmountID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			SavingAmountID: savingAmountID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessWalletRevertAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertBusinessWalletFailure(responseData.data));
		} else {
			yield put(revertBusinessWalletSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertBusinessWalletFailure(error));
	}
}

export function* resetBusinessWalletRevertResponse() {
	yield put(revertBusinessWalletResponseChanged());
}

export function* onBusinessWalletDetailsRevert() {
	yield takeLatest(
		businessCollectionActionTypes.DELETE_BUSINESS_WALLET_START,
		revertBusinessWalletList,
	);
}

export function* onBusinessWalletDetailsRevertResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.DELETE_BUSINESS_WALLET_RESPONSE_RESET,
		resetBusinessWalletRevertResponse,
	);
}
/** *********************  REVERT BUSINESS WALLET LIST END ******************** */

/** *********************  BUSINESS LOAN CARD START ******************** */
export function* businessLoanCardPDFExport({ payload }: any) {
	try {
		const key = 'BusinessLoanCardPDFKey';
		const { databaseName, companyID, loanIndexID, businessID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexID: loanIndexID,
			BusinessID: businessID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getBusinessLoanCardPDF, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBusinessLoanCardPDFFailure(responseData.data));
		} else {
			yield put(getBusinessLoanCardPDFSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBusinessLoanCardPDFFailure(error));
	}
}

export function* getBusinessLoanCardPDFResponse() {
	yield put(getBusinessLoanCardPDFResponseChanged());
}

export function* onBusinessLoanCardPDF() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_START,
		businessLoanCardPDFExport,
	);
}

export function* onBusinessLoanCardPDFResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_LOAN_CARD_PDF_RESPONSE_RESET,
		getBusinessLoanCardPDFResponse,
	);
}
/** *********************  BUSINESS LOAN CARD END ******************** */

/** *********************  BUSINESS REPAYMENT START ******************** */
export function* businessRepaymentPDFExport({ payload }: any) {
	try {
		const key = 'BusinessRepaymentPDFKey';
		const {
			databaseName,
			companyID,
			loanIndexID,
			memberID,
			branchID,
			centerID,
			loanIndexGroupMemberID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexID: loanIndexID,
			MemberID: memberID,
			BranchID: branchID,
			CenterID: centerID,
			LoanIndexGroupBusinessID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getBusinessRepaymentPDF, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBusinessRepaymentPDFFailure(responseData.data));
		} else {
			yield put(getBusinessRepaymentPDFSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBusinessRepaymentPDFFailure(error));
	}
}

export function* getRepaymentPDFResponse() {
	yield put(getBusinessLoanCardPDFResponseChanged());
}

export function* onBusinessGetRepaymentPDF() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_START,
		businessRepaymentPDFExport,
	);
}

export function* onBusinessRepaymentPDFResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_REPAYMENT_PDF_RESPONSE_RESET,
		getRepaymentPDFResponse,
	);
}
/** *********************  BUSINESS REPAYMENT END ******************** */

/** *********************  BUSINESS LOAN CARD REPORT START ******************** */
export function* businessLoanCardReport({ payload }: any) {
	try {
		const key = 'LoanCardReportKey';
		const {
			databaseName,
			companyID,
			loanIndexID,
			businessID,
			branchID,
			centerID,
			userID,
			loanIndexGroupBusinessID,
			generalCompanyID,
			requestID,
			groupID,
		} = payload;

		const jsonData = {
			DatabaseName: databaseName,
			GeneralCompanyID: generalCompanyID,
			CompanyID: companyID,
			UserID: userID,
			LoanIndexID: loanIndexID,
			GroupID: groupID,
			BusinessID: businessID,
			BranchID: branchID,
			CenterID: centerID,
			RequestID: requestID,
			LoanIndexGroupBusinessID: loanIndexGroupBusinessID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(geBusinessLoanCardReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBusinessLoanCardReportFailure(responseData.data));
		} else {
			yield put(getBusinessLoanCardReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBusinessLoanCardReportFailure(error));
	}
}

export function* getBusinessLoanCardReport() {
	yield put(getBusinessLoanCardReportResponseChanged());
}

export function* onBusinessLoanCardReport() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_START,
		businessLoanCardReport,
	);
}

export function* onBusinessLoanCardReportResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_LOAN_CARD_REPORT_RESPONSE_RESET,
		getBusinessLoanCardReport,
	);
}
/** *********************  BUSINESS LOAN CARD REPORT END ******************** */

/** *********************  BUSINESS LOAN COLLECTION APPROVAL START ******************** */
export function* businessLoanCollectionApproval({ payload }: any) {
	try {
		const key = 'MemberLoanCollectionApprovalKey';
		const { databaseName, companyID, loanPaidID, memberID, loanIndexGroupBusinessID } = payload;

		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanPaidID: loanPaidID,
			MemberID: memberID,
			LoanIndexGroupMemberID: loanIndexGroupBusinessID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessLoanCollectionApprovalAPI, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(businessLoanCollectionApprovalFailure(responseData.data));
		} else {
			yield put(businessLoanCollectionApprovalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(businessLoanCollectionApprovalFailure(error));
	}
}

export function* getBusinessLoanCollectionApproval() {
	yield put(businessLoanCollectionApprovalResponseChanged());
}

export function* onBusinessLoanCollectionApproval() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_START,
		businessLoanCollectionApproval,
	);
}

export function* onBusinessLoanCollectionApprovalResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_LOAN_COLLECTION_APPROVAL_RESPONSE_RESET,
		getBusinessLoanCollectionApproval,
	);
}
/** *********************  BUSINESS LOAN COLLECTION APPROVAL END ******************** */

/** *********************  BUSINESS LOAN COLLECTION ARREAR LOAN PAID START ******************** */
export function* businessArrearLoanPaidEntrySaga({ payload }: any) {
	try {
		debugger;
		const key = 'updateArrearLoanPaidKey';
		const {
			paidID,
			arrearPrincipal,
			arrearInterest,
			amountReceived,
			companyID,
			databaseName,
			isArrearCollection,
			userID,
			userName,
			userAccessBranchID,
			advanceAmount,
			payFromWalet,
			loanIndexGroupMemberID,
			memberID,
			paymentFrom,
			isThriftPayed,
			thriftAmount,
			additionalChargesPaid,
			collectionMode,
			receiptNumber,
			twoThousand,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenominationAmount,
			penaltyPaidAmount,
			repaymetDate,
			recivedArrearPrinciple,
			recivedArrearInterest,
			arreaLoanPrincipal,
			arreaLoanInterest,
		} = payload;
		const jsonData = {
			TwoThousand: twoThousand,
			FiveHundred: fiveHundred,
			TwoHundred: twoHundred,
			Hundred: hundred,
			Fifty: fifty,
			Twenty: twenty,
			Ten: ten,
			Five: five,
			Two: two,
			One: one,
			TotalDenominationAmount: totalDenominationAmount,
			LoanPaidID: paidID,
			ArreaLoanPrincipal: arreaLoanPrincipal || arrearPrincipal,
			ArreaLoanInterest: arreaLoanInterest || arrearInterest,
			ReceivedArrearPrincipal: recivedArrearPrinciple,
			ReceivedArrearInterest: recivedArrearInterest,
			TotalArrearReceivedLoanAmount: amountReceived,
			TotalPenaltyPaidAmount: penaltyPaidAmount,
			CompanyID: companyID,
			ArrearCollectionDate: repaymetDate,
			DatabaseName: databaseName,
			IsArrearCollection: isArrearCollection,
			CreatedBy: userID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			AdvanceAmount: advanceAmount,
			PayFromWalet: payFromWalet,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			MemberID: memberID,
			PaymentFrom: paymentFrom,
			IsThriftPayed: isThriftPayed,
			ThriftAmount: thriftAmount,
			AdditionalChargesPaid: additionalChargesPaid,
			CollectionMode: collectionMode,
			ReceiptNumber: receiptNumber,
			PaidID: paidID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessArrearLoanPaidEntry, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(businessCollectionLoanPaidArrearFailure(responseData.data));
		} else {
			yield put(businessCollectionLoanPaidArrearSuccess(responseData.data));
		}
	} catch (error) {
		yield put(businessCollectionLoanPaidArrearFailure(error));
	}
}

export function* businessArrearCollectionLoanPaidResponse() {
	yield put(businessCollectionLoanPaidArrearReponseChanged());
}

export function* onBusinessLoanArrearCollectionLoanPaidEntry() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_START,
		businessArrearLoanPaidEntrySaga,
	);
}

export function* onBusinessLoanArrearCollectionLoanPaidEntryResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ARREAR_ENTRY_REPONSE_RESET,
		businessArrearCollectionLoanPaidResponse,
	);
}
/** *********************  BUSINESS LOAN COLLECTION ARREAR LOAN PAID ENTRY END ******************** */

/** *********************  BUSINESS LOAN COLLECTION APPROVAL START ******************** */
export function* businessLoanPaidEntrySaga({ payload }: any) {
	try {
		debugger;
		const key = 'UpdateLoanPaidKey';
		const {
			twoThousand,
			fiveHundred,
			twoHundred,
			hundred,
			fifty,
			twenty,
			ten,
			five,
			two,
			one,
			totalDenominationAmount,
			arrearInterest,
			arrearPrincipal,
			amountReceived,
			penaltyAmount,
			penaltyPaidAmount,
			companyID,
			whenToPay,
			repaymetDate,
			advanceAmount,
			userID,
			payFromWalet,
			databaseName,
			uICollectionDate,
			collectedFrom,
			collectedBy,
			dueLeft,
			totalDue,
			loanIndexGroupMemberID,
			collectionMode,
			chequeNumber,
			receiptNumber,
			branchCashAccountID,
			branchBankAccountID,
			walletAccountID,
			infogCompanyID,
			memberUniqueID,
			memberName,
			branchID,
			paymentFrom,
			isThriftPayed,
			paidID,
			arreaLoanPrincipal,
			receivedArrearInterest,
			arreaLoanInterest,
			receivedArrearPrinciple,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
			TwoThousand: twoThousand,
			FiveHundred: fiveHundred,
			TwoHundred: twoHundred,
			Hundred: hundred,
			Fifty: fifty,
			Twenty: twenty,
			Ten: ten,
			Five: five,
			Two: two,
			One: one,
			TotalDenominationAmount: totalDenominationAmount,
			ArrearInterest: arrearInterest,
			ArrearPrincipal: arrearPrincipal,
			AmountReceived: amountReceived,
			PenaltyAmount: penaltyAmount,
			PenaltyPaidAmount: penaltyPaidAmount,
			WhenToPay: whenToPay,
			RepaymetDate: repaymetDate,
			AdvanceAmount: advanceAmount,
			UserID: userID,
			PayFromWalet: payFromWalet,
			UICollectionDate: uICollectionDate,
			CollectedFrom: collectedFrom,
			CollectedBy: collectedBy,
			DueLeft: dueLeft,
			TotalDue: totalDue,
			CollectionMode: collectionMode,
			ChequeNumber: chequeNumber,
			ReceiptNumber: receiptNumber,
			BranchCashAccountID: branchCashAccountID,
			BranchBankAccountID: branchBankAccountID,
			WalletAccountID: walletAccountID,
			InfogCompanyID: infogCompanyID,
			MemberUniqueID: memberUniqueID,
			MemberName: memberName,
			BranchID: branchID,
			PaymentFrom: paymentFrom,
			IsThriftPayed: isThriftPayed,
			PaidID: paidID,
			ArreaLoanPrincipal: arreaLoanPrincipal,
			ArreaLoanInterest: arreaLoanInterest,
			ReceivedArrearPrincipal: receivedArrearPrinciple,
			ReceivedArrearInterest: receivedArrearInterest,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessLoanPaidEntry, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(businessCollectionLoanPaidFailure(responseData.data));
		} else {
			yield put(businessCollectionLoanPaidSuccess(responseData.data));
		}
	} catch (error) {
		yield put(businessCollectionLoanPaidFailure(error));
	}
}

export function* businessCollectionLoanPaidResponse() {
	yield put(businessCollectionLoanPaidReponseChanged());
}

export function* onBusinessLoanCollectionLoanPaidEntry() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_START,
		businessLoanPaidEntrySaga,
	);
}

export function* onBusinessLoanCollectionLoanPaidEntryResponseReset() {
	yield takeLatest(
		businessCollectionActionTypes.BUSINESS_COLLECTION_LOAN_PAID_ENTRY_REPONSE_RESET,
		businessCollectionLoanPaidResponse,
	);
}
/** *********************  BUSINESS LOAN COLLECTION APPROVAL END ******************** */

export function* businessCollectionSaga() {
	yield all([
		call(onGetSearchBusinessLoanListDetails),
		call(onGetSearchBusinessLoanListResponseReset),
		call(onGetBusinessLoanInfoDetails),
		call(onGetBusinessLoanInfoResponseReset),
		call(onBusinessCollectionUpdate),
		call(onBusinessCollectionUpdateResponseReset),
		call(onBusinessDeathUpdate),
		call(onBusinessDeathUpdateResponseReset),
		call(onBusinessInterestWaiverUpdate),
		call(onBusinessInterestWaiverUpdateResponseReset),
		call(onBusinessCollectionRevert),
		call(onBusinessCollectionRevertResponseReset),
		call(onBusinessCollectionDetailsFetch),
		call(onBusinessCollectionDetailsFetchResponseReset),
		call(onBusinessWalletDetailsFetch),
		call(onBusinessWalletDetailsFetchResponseReset),
		call(onBusinessQrDetailsFetch),
		call(onBusinessQrDetailsFetchResponseReset),
		call(onBusinessRepaymentDetailsFetch),
		call(onBusinessRepaymentDetailsFetchResponseReset),
		call(onBusinessWalletDetailsRevert),
		call(onBusinessWalletDetailsRevertResponseReset),
		call(onBusinessLoanCardPDFResponseReset),
		call(onBusinessLoanCardPDF),
		call(onBusinessGetRepaymentPDF),
		call(onBusinessRepaymentPDFResponseReset),
		call(onBusinessLoanCardReport),
		call(onBusinessLoanCardReportResponseReset),
		call(onBusinessLoanCollectionApproval),
		call(onBusinessLoanCollectionApprovalResponseReset),
		call(onBusinessWalletDetailsAdd),
		call(onBusinessWalletDetailsAddResponseReset),
		call(onBusinessLoanArrearCollectionLoanPaidEntryResponseReset),
		call(onBusinessLoanArrearCollectionLoanPaidEntry),
		call(onBusinessLoanCollectionLoanPaidEntryResponseReset),
		call(onBusinessLoanCollectionLoanPaidEntry),
	]);
}
